import React from 'react';
import Icon from '../AppIcon';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/12409784155', '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all duration-300 transform hover:scale-110 flex items-center space-x-3 group"
      aria-label="Contact us on WhatsApp"
    >
      <Icon name="MessageCircle" size={24} className="text-white" />
      <span className="hidden group-hover:inline-block text-sm font-semibold whitespace-nowrap pr-2">
        Assistance WhatsApp
      </span>
    </button>
  );
};

export default WhatsAppButton;